const GRID = 21;

const finderBoxes: Array<[number, number]> = [
  [0, 0],
  [0, GRID - 7],
  [GRID - 7, 0],
];

function inFinderZone(row: number, col: number) {
  return finderBoxes.some(
    ([r0, c0]) => row >= r0 && row < r0 + 7 && col >= c0 && col < c0 + 7,
  );
}

function finderFilled(row: number, col: number) {
  const box = finderBoxes.find(
    ([r0, c0]) => row >= r0 && row < r0 + 7 && col >= c0 && col < c0 + 7,
  );
  if (!box) return false;
  const dr = row - box[0];
  const dc = col - box[1];
  const ring = dr === 0 || dr === 6 || dc === 0 || dc === 6;
  const core = dr >= 2 && dr <= 4 && dc >= 2 && dc <= 4;
  return ring || core;
}

function dataFilled(row: number, col: number) {
  return (row * 7 + col * 13 + row * col + (row % 2) * 5) % 3 === 0;
}

const cells: boolean[] = [];
for (let row = 0; row < GRID; row += 1) {
  for (let col = 0; col < GRID; col += 1) {
    cells.push(inFinderZone(row, col) ? finderFilled(row, col) : dataFilled(row, col));
  }
}

interface QrPlaceholderProps {
  className?: string;
}

export default function QrPlaceholder({ className = '' }: QrPlaceholderProps) {
  return (
    <div
      className={`grid w-full h-full bg-background-50 ${className}`}
      style={{ gridTemplateColumns: `repeat(${GRID}, 1fr)`, gridAutoRows: '1fr' }}
      aria-hidden="true"
    >
      {cells.map((filled, index) => (
        <span
          key={index}
          className={filled ? 'bg-foreground-950' : 'bg-transparent'}
        />
      ))}
    </div>
  );
}